import React from 'react';
import { Spinner } from 'react-bootstrap';
import { usePatientService } from '~/services';
import { enumValue, gapIsPending } from '~/util';

export interface FocClearProps {
    focGap: GapType;
    patientId: number;
    tab: string;
    rolePermission: boolean;
    setDisabled: (x: boolean) => void;
    onSuccess: () => void;
    disabled: boolean;
}

export function FocClear({
    focGap,
    patientId,
    tab,
    rolePermission,
    setDisabled,
    onSuccess,
    disabled,
}: FocClearProps) {
    const { deleteSubmissionAnswer, updateFocGap } = usePatientService();
    const [saving, setSaving] = React.useState(false);

    async function handleClear() {
        try {
            setSaving(true);
            setDisabled(true);
            if (focGap.submission_answer?.status === enumValue(['submission', 'status', 'New'])) {
                // Delete submission_answer
                await deleteSubmissionAnswer(
                    enumValue(['gap', 'type', 'FOC Gap']) as number,
                    focGap.id,
                    focGap.submission_answer.id
                );
            } else {
                // This submission was previously sent, so we purposefully
                // change this to null rather than deleting
                await updateFocGap(focGap.id, patientId, {
                    submission_answer: null,
                    updated_at: focGap.updated_at,
                });
            }
            onSuccess();
        } catch (e) {
            setSaving(false);
            setDisabled(false);
        }
    }

    if (
        tab !== 'Measures' ||
        !gapIsPending(focGap) ||
        !focGap.submission_answer ||
        !rolePermission
    ) {
        return null;
    }

    return (
        <div className="text-center">
            <button
                className="btn btn-warning"
                type="button"
                onClick={handleClear}
                disabled={disabled}
            >
                {saving && <Spinner animation="border" role="status" size="sm" className="me-1" />}
                Clear
            </button>
        </div>
    );
}
